<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll;">
            <div style="margin-top: 33px; padding: 0 30px;">
                <div style="font-size: 30px; font-weight: 900; position: relative; display: inline-block;">
                    <div style="position: relative; z-index: 2;">시크릿 에이전트</div>
                    <div class="yellow_line" ></div>
                </div>
                <div style="font-weight: 500; font-size: 20px; margin-top: 14px;">단돈 <span style="font-weight: 700;">100,000원</span>으로,</div>
                <div style="font-weight: 500; font-size: 20px; margin-top: 8px;">
                    <span style="font-weight: 700; color: var(--color-main);">당신의 전담 에이전트</span>가 되어드립니다.
                </div>
                <div style="border-radius: 12px; margin-top: 10px; display: inline-block; padding: 4px 12px; background-color: #F8F9FA; border: 1px solid #E9E9E9;">
                    <div style="display: flex; gap: 6px; align-items: center;">
                        <img style="width: 13px;" :src="require('@/assets/img/only_elite.png')" alt="">
                        <div style="font-weight: 700; font-size: 12px; color: #e80000; line-height: 24px;">엘리트 선수만 이용 가능한 서비스입니다.</div>
                    </div>
                </div>
            </div>
            <swiper ref="secretAgentWrapper" style="margin-top: 6px; border-radius: 12px; margin-bottom: 15px; overflow: hidden;" :options="swiperOption" role="tablist" @slideChange="detectSlideChanged">
                <swiper-slide v-for="each, i in secretAgentArr" :key="i + 'secret_agent_item'" style="border-radius: 12px; height: 471px;" role="tab">
                    <div style="height: 283px; text-align: center; display: flex; justify-content: center; align-items: end;">
                        <object style="pointer-events: none;" :data="each.img_path" type=""></object>
                    </div>
                    <div style="margin-top: 5px; padding: 0 30px;">
                        <div v-if="i !== secretAgentArr.length - 1" style="width: 66px; height: 28px; line-height: 28px; color: #fff; font-weight: 500; text-align: center; background-color: #210f03; border-radius: 8px; font-size: 14px;">혜택 내용</div>
                        <div v-else style="width: 66px; height: 28px; line-height: 28px; color: #fff; font-weight: 500; text-align: center; background-color: #939393; border-radius: 8px; font-size: 14px;">추가 옵션</div>
                        <div style="margin-top: 12px; display: flex; gap: 9px;">
                            <div style="width: 24px; height: 24px; flex-shrink: 0; background-color: #201f03; border-radius: 50%; color: #fff; display: flex; justify-content: center; align-items: center; font-weight: 700; font-size: 12px;">
                                <div>{{ i + 1 }}</div>
                            </div>
                            <div>
                                <div v-if="i !== secretAgentArr.length - 1" style="color: var(--color-main); font-weight: 700; font-size: 20px; line-height: 24px;">{{ each.title }}</div>
                                <div v-else style="font-weight: 700; font-size: 20px; line-height: 24px; white-space: nowrap;">{{ each.title }}<span style="font-size: 12px; font-weight: 700;"> (선택)</span></div>
                                <div v-html="each.subTitle" style="margin-top: 9px; line-height: 24px; color: #606060;"></div>
                                <div v-if="i < 2" style="margin-top: 3px; font-weight: 700; font-size: 12px; line-height: 16px; color: #bdbdbd;">※ 일부 구단은 테스트 진행이 어려울 수 있습니다.</div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; bottom: 0px; text-align: center; display:inline-block;"></div>
            </swiper>
        </div>
        <div style="padding: 0 12px; margin-bottom: 15px;">
            <div :class="activeIndex === secretAgentArr.length - 1 ? 'active' : 'un_active'" style="height: 62px; line-height: 62px; text-align: center; border-radius: 12px; font-weight: 700;">시작하기</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name: 'SecretAgent',
    components: {
        MercenaryHeader, swiper, swiperSlide
    },
    data() {
        return {
            swiperOption: {
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
            },
            activeIndex: 0,
            secretAgentArr: [
                { 
                    img_path: require('@/assets/img/secret_step_1.svg'), 
                    title: '100% 비공개 입단 절차 진행',
                    subTitle: '입단 요청서는 외부에 전혀 공개되지 않으며,<br>모든 입단 과정은 비밀리에 진행됩니다.'
                },
                { 
                    img_path: require('@/assets/img/secret_step_2.svg'),
                    title: '희망하는 3개 구단 테스트 기회 제공',
                    subTitle: '회원님이 관심 있는 팀의 감독님께<br>사커하우가 직접 컨택을 도와드립니다.'
                },
                { 
                    img_path: require('@/assets/img/secret_step_3.svg'),
                    title: '입단 테스트 준비 매니지먼트',
                    subTitle: '입단 테스트 일정 안내부터<br>준비사항 체크, 몸 관리 방법 등<br>테스트 전까지 필요한 전 과정을 케어해드립니다.'
                },
                { 
                    img_path: require('@/assets/img/secret_step_4.svg'), 
                    title: '감독님의 현실적인 피드백',
                    subTitle: '해당 팀에서 거절을 받더라도,<br>감독님의 직접적인 현실적 피드백을 받아<br>무엇을 보완해야 할지 명확하게 알 수 있습니다.'
                },
                { 
                    img_path: require('@/assets/img/secret_step_5.svg'), 
                    title: '입단 테스트 현장 촬영 & 편집 서비스',
                    subTitle: '입단 테스트를 전문 촬영·편집하여<br>포트폴리오용 하이라이트부터 추억 영상까지<br>고품질로 제작해드립니다.'
                },
            ]
        }
    },
    methods: {
        detectSlideChanged() {
            this.activeIndex = this.$refs.secretAgentWrapper.swiper.realIndex
        }
    }
}
</script>

<style scoped>
.yellow_line {
    width: 200px; 
    height: 8px;
    position: absolute; 
    background-color: #FFFF2A; 
    z-index: 1; 
    left: 50%;
    transform: translateX(-50%);
    bottom: -4px;
}
.swiper-pagination>>>.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background-color: #FFDEC7;
    opacity: 1;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: var(--color-main)
}

.active {
    background-color: var(--color-main);
}

.un_active {
    background-color: #ddd;
    color: #fff;
}
</style>